<div class="container-fluid">
    <div class="container-xxxl mt-5">
        <div class="items d-flex d-print-block justify-content-between flex-column-reverse flex-xl-row pt-4">
            <app-view-sources-references class="flex-grow sources d-print-block"></app-view-sources-references>

            <p class="p-0 m-0 text-xl-end fs-8 fs-md-6">{{ lastUpdatedDate }}</p>
        </div>
    </div>
</div>
